import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { PersonaService } from "../servicios/persona.service";
import { UsuarioService } from "../servicios/usuario.service";
import { EntregaService } from "../servicios/entrega.service";
import { AgenciaService } from "../servicios/agencia.service";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import * as _moment from "moment";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { Utils } from "../utils/utils";
import { DialogDocumentoComponent } from '../dialogs/dialog-documento/dialog-documento.component';
import { MatDialog } from '@angular/material/dialog';

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD"
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD"
  }
};

export interface Usuario {
  id: string;
  valor: string;
}

@Component({
  selector: "app-entregas-transportador",
  templateUrl: "./entregas-transportador.component.html",
  styleUrls: ["./entregas-transportador.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class EntregasTransportadorComponent implements OnInit {
  entregasGroup: FormGroup;
  loadingAgencias = false;
  loadingUsuarios = false;
  loading = false;
  usuarioConsulta = "";
  filteredUsuarios: Observable<Usuario[]>;
  agencias = [];
  usuarios = [];
  dataEntregas = [];
  haveData = false;
  timeRunning = 0;
  alternate: boolean = false;
  isExpanded: boolean = false;
  mostrarIcono: boolean = true;
  searchForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private servicePersona: PersonaService,
    private serviceUsuario: UsuarioService,
    private serviceEntrega: EntregaService,
    private servicioAgencia: AgenciaService,
    private dialog: MatDialog,
    public ruta: Utils
  ) {
    this.entregasGroup = this.fb.group({
      idAgencia: ["", Validators.required],
      usuarioCtrl: ["", Validators.required],
      fechaInicial: [new Date(), Validators.required],
      fechaFinal: [new Date(), Validators.required]
    });

    this.searchForm = this.fb.group({
      searchText: [""]
    });

    const fechaHoy = new Date();
    const nFecha = _moment(fechaHoy, "YYYY-MM-DD").format("YYYY-MM-DD");
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.loadingAgencias = true;
    this.servicioAgencia
      .getAgencia(infoUsuario[0].IdUsuario, 0)
      .subscribe(result => {
        this.agencias = result;
        this.agencias.unshift({
          id: "0",
          valor: "TODOS"
        });
        this.entregasGroup.controls["idAgencia"].setValue("0");
        this.loadingAgencias = false;
        this.entregasGroup.get("idAgencia").valueChanges.subscribe(value => {
          this.cargarUsuariosAgencia();
        });
        //console.log(this.agencias);
      });

    this.loadingUsuarios = true;
    this.serviceUsuario
      .getUsuariosPersonas(2, infoUsuario[0].IdUsuario, 0)
      .subscribe(result => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS"
        });
        this.entregasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS"
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.entregasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map(usuario =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });

    this.cargarInformacion(0, this.usuarioConsulta, 0, nFecha, nFecha);
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

  cargarInformacion(
    agencia,
    usuarioConsulta,
    usuario,
    fechaInicial,
    fechaFinal
  ) {
    this.loading = true;
    this.serviceEntrega
      .getInformeEntregasRealizadas(
        agencia,
        usuarioConsulta,
        usuario,
        fechaInicial,
        fechaFinal
      )
      .subscribe(data => {
        this.dataEntregas = data;
        //console.log(this.dataEntregas);
        this.loading = false;
        if (data.length > 0) {
          this.haveData = true;
        }

        if (this.timeRunning == 0) {
          //this.dtTrigger.next();
        } else {
          //this.reRender();
        }
        this.timeRunning++;
      });
  }

  cargarUsuariosAgencia() {
    this.loadingUsuarios = true;
    const agencia = this.entregasGroup.get("idAgencia").value;

    this.serviceUsuario
      .getUsuariosPersonas(2, this.usuarioConsulta, agencia)
      .subscribe(result => {
        this.usuarios = result;
        this.usuarios.unshift({
          id: "0",
          valor: "TODOS"
        });
        this.entregasGroup.controls["usuarioCtrl"].setValue({
          id: "0",
          valor: "TODOS"
        });
        this.loadingUsuarios = false;
        this.filteredUsuarios = this.entregasGroup
          .get("usuarioCtrl")
          .valueChanges.pipe(
            startWith(""),
            map(usuario =>
              usuario ? this._filterUsuarios(usuario) : this.usuarios.slice()
            )
          );
      });
  }

  private _filterUsuarios(value: any): Usuario[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    console.log(filterValue);
    //const filterValue = value.valor.toLowerCase();

    return this.usuarios.filter(
      usuario => usuario.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  displayFn(usuario) {
    //console.log(JSON.stringify(usuario));
    return usuario ? usuario.valor : usuario;
  }

  onHeaderClick(event, index) {

  }

  onDotClick(event, index) {

  }


  busqueda() {


    //console.log(this.entregasGroup.get('idAgencia').value);
    //return;
    const usuarioConsulta = this.usuarioConsulta;
    const agencia = this.entregasGroup.get('idAgencia').value;
    const usuario = this.entregasGroup.get('usuarioCtrl').value;
    const fechaInicial = _moment(this.entregasGroup.get('fechaInicial').value, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const fechaFinal = _moment(this.entregasGroup.get('fechaFinal').value, 'YYYY-MM-DD').format('YYYY-MM-DD');

    //console.log(tipoConsulta);
    //return;
    this.cargarInformacion(agencia, usuarioConsulta, usuario.id, fechaInicial, fechaFinal);
  }

  verDocumento (ordenSAP, idServicio, tipoImagen){
    const params = {
      ordenSAP:ordenSAP,
      idServicio:idServicio,
      tipoImagen:tipoImagen
    }
    const dialogRef = this.dialog.open(DialogDocumentoComponent, {
      data: params,
      width: '100em',
      //disableClose: true
    });


    dialogRef.afterClosed().subscribe(result => {
      /*if (result) {
        this.refrescaBusqueda();
      }*/
      console.log('Resultado es :' + result);
    });


  }

  exportarExcel(){
    const fileName = 'entregasRealizadas.xlsx';

    let data = JSON.parse(JSON.stringify(this.dataEntregas));
    //let data = this.dataEntregas;

    data.forEach(element => {
      delete element.busqueda;
      delete element.tieneFoto;
      delete element.tieneFirma;
      delete element.tieneDocumento;
      delete element.sincronizado;
      delete element.enRutaOperador;
      delete element.idUsuarioAsignado;
      delete element.idTpoNovedad;
    });

		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'entregas');

		XLSX.writeFile(wb, fileName);
  }


}
